module.exports = __webpack_public_path__ + "img/refresh-ccw-04.158ef314.svg";